import request from '@/plugins/axios'

// 操作日志-分页
export function logPage(data) {
    return request({
        url: '/sys/log/page',
        method: 'post',
        data: data
    })
}